


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ShCommonBadgeList extends Vue {

  // @Prop({ type: Object, default: {} }) protected items!: any;

  // protected productSelected(productId: string) {
  //   this.$emit('productSelected', productId);
  // }

  // protected productRemove(productId: string) {
  //   this.$emit('productRemove', productId);
  // }

  // protected productEdit(productId: string) {
  //   this.$emit('productEdit', productId);
  // }

  // protected get sortedItems() {

  //   return Object.keys(this.items).sort();

  // }

}

